"use client";

import React from "react";
import { useSearchParams } from "next/navigation";
import ObituaryListBanner from "../components/appcomponents/ObituaryListBanner";
import { findCityFromSlug, slugToCity } from "@/utils/citySlug";
import PogrebiListComponent from "../components/appcomponents/PogrebiListComponent";
import SponsorComponent from "../components/appcomponents/SponsorComponent";
import Carousel from "../components/slidercomponents/Carousel";
import MainOptions from "../components/appcomponents/MainOptions";
import PogrebiLocalFloristComp from "../components/PogrebiLocalFloristComp";
import CommonFooter from "../components/appcomponents/CommonFooter";
const PogrebiListContent = ({
  cityParam,
  h1Text,
  regionSubtitle,
}: {
  cityParam?: string;
  h1Text?: string;
  regionSubtitle?: string;
}) => {
  const urlSearchParams = useSearchParams();
  const region = urlSearchParams.get("region");
  const city = cityParam || urlSearchParams.get("city");
  const decodedCity = city
    ? (() => {
        try {
          return decodeURIComponent(city);
        } catch {
          return city;
        }
      })()
    : undefined;
  // Normalize slug-like city values (e.g. novo+mesto, nova+gorica) for subtitle display.
  const cityDisplay = decodedCity
    ? findCityFromSlug(decodedCity) || slugToCity(decodedCity)
    : undefined;
  const displayH1 = h1Text || "Pogrebi";
  // City takes priority; fall back to server-resolved region subtitle from regionPogrebiOverrides.
  const subtitleDisplay = cityDisplay || regionSubtitle || undefined;

  return (
    <>
      <ObituaryListBanner
        image={"/pogrebi_ozadje.png"}
        label={"Pogrebi"}
        alt="pogrebi ozadje"
        h1Text={displayH1}
        subtitleText={subtitleDisplay}
      />
      <PogrebiListComponent city={city || null} />
      <Carousel city={city || null} region={region || null} />
      <SponsorComponent
        text="Brez pomoči partnerjev ne bi šlo"
        region={region || null}
        city={city || null}
      />
      <MainOptions />
      <PogrebiLocalFloristComp />
      <CommonFooter currentPage="/pogrebi" />
    </>
  );
};

export default PogrebiListContent;
